module.exports = __webpack_public_path__ + "img/single-workout.22935e79.png";